<template>
  <el-carousel :interval="5000" height="100%" arrow="always" class="carousel-layout">
    <el-carousel-item v-for="(item, index) in currentSlideshow" :key="item.id || index">
      <!-- <img class="image" src="@images/bg/top_logo.png" alt="" /> -->
      <div class="carousel-item-layout">
        <img class="image" :src="item.localUrl" :alt="item.contentTitle || ''" />
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import { Carousel, CarouselItem } from 'element-ui'
import { getData } from '@/request/api/model'

export default {
  name: 'Home',
  components: {
    ElCarousel: Carousel,
    ElCarouselItem: CarouselItem
  },
  data() {
    return {
      language: localStorage.getItem('Language'),
      cnSlideshow: [],
      enSlideshow: []
    }
  },
  computed: {
    currentSlideshow() {
      return this.language === 'zh-CN' ? this.cnSlideshow : this.enSlideshow
    }
  },
  created() {
    if (this.language === 'zh-CN') {
      this.getCNData()
    } else {
      this.getENData()
    }
  },
  methods: {
    async getCNData() {
      this.cnSlideshow = await this.getSlideshowData('0,1')
    },
    async getENData() {
      this.enSlideshow = await this.getSlideshowData('0,2')
    },
    async getSlideshowData(contentType) {
      try {
        const res = await getData({
          categoryId: '2077634653602623489',
          contentType,
          publishChannel: '0,1'
        })

        if (!res || res.code !== 0 || !Array.isArray(res.data)) {
          return []
        }

        return res.data.reduce((list, item) => {
          const fileList = Array.isArray(item.contentFileList) ? item.contentFileList : []
          const localUrl = fileList.find((url) => typeof url === 'string' && url.trim())
          if (localUrl) {
            list.push({
              localUrl
            })
          }
          return list
        }, [])
      } catch (error) {
        console.error(error)
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-layout {
  height: 100%;
  // /deep/ .el-carousel__container {
  //   height: 100%;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  // }
  /deep/ .el-carousel__arrow {
    width: 5vw;
    height: 5vw;

    i {
      font-size: 2.7vw;
    }
  }
  .carousel-item-layout {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;

    .image {
      width: 100%;
    }
  }
}
</style>
